// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.escher-container .picker {
  top: 35px;
  margin-left: -7px;
  position: absolute;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.escher-container .pickerBox {
  position: absolute;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.375);
  width: 14px;
  height: 35px;
  top: -35px
}

.escher-container .scaleTrack .rightOptions {
  position: absolute;
  left: -76px;
}

.escher-container .pickerOptions {
  box-shadow: 0 2px 14px #c5c5c5;
  margin-top: 1px;
  display: inline-flex;
  flex-direction: column;
  width: 90px;
}

.escher-container .pickerOptions * {
  font-size: 12px;
}

.escher-container .pickerOptions .option {
  padding: 3px 0px;
}

.escher-container .pickerOptions .typePicker {
  width: 20px;
  position: absolute;
  left: 70px;
  top: 1px;
  right: 0px;
  height: 14px;
  background-color: rgb(232, 232, 232);
}

.escher-container .pickerOptions .colorOptions {
  display: inline-flex;
}

.escher-container .colorOptions .colorText {
  padding: 3px 0px;
  width: 100%;
}

.escher-container .colorOptions .colorWheel {
  padding: 0px;
  position: absolute;
  right: 0;
  height: 24px;
  width: 21px;
  border: 1px solid black;
}

.escher-container .picker .trashDiv {
  position: absolute;
  top: -56px;
  font-size: 17px;
}

.escher-container .picker .trashDiv * {
  font-size: 17px;
  cursor: pointer;
}

.escher-container .picker .icon-trash-empty {
  margin: -5px;
}

.escher-container .scaleEditor :disabled {
  background: #f1ecfa;
}

.escher-container .scaleEditor input[type=color]:disabled {
  margin-top: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/Picker.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".escher-container .picker {\n  top: 35px;\n  margin-left: -7px;\n  position: absolute;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.escher-container .pickerBox {\n  position: absolute;\n  cursor: pointer;\n  background: rgba(0, 0, 0, 0.375);\n  width: 14px;\n  height: 35px;\n  top: -35px\n}\n\n.escher-container .scaleTrack .rightOptions {\n  position: absolute;\n  left: -76px;\n}\n\n.escher-container .pickerOptions {\n  box-shadow: 0 2px 14px #c5c5c5;\n  margin-top: 1px;\n  display: inline-flex;\n  flex-direction: column;\n  width: 90px;\n}\n\n.escher-container .pickerOptions * {\n  font-size: 12px;\n}\n\n.escher-container .pickerOptions .option {\n  padding: 3px 0px;\n}\n\n.escher-container .pickerOptions .typePicker {\n  width: 20px;\n  position: absolute;\n  left: 70px;\n  top: 1px;\n  right: 0px;\n  height: 14px;\n  background-color: rgb(232, 232, 232);\n}\n\n.escher-container .pickerOptions .colorOptions {\n  display: inline-flex;\n}\n\n.escher-container .colorOptions .colorText {\n  padding: 3px 0px;\n  width: 100%;\n}\n\n.escher-container .colorOptions .colorWheel {\n  padding: 0px;\n  position: absolute;\n  right: 0;\n  height: 24px;\n  width: 21px;\n  border: 1px solid black;\n}\n\n.escher-container .picker .trashDiv {\n  position: absolute;\n  top: -56px;\n  font-size: 17px;\n}\n\n.escher-container .picker .trashDiv * {\n  font-size: 17px;\n  cursor: pointer;\n}\n\n.escher-container .picker .icon-trash-empty {\n  margin: -5px;\n}\n\n.escher-container .scaleEditor :disabled {\n  background: #f1ecfa;\n}\n\n.escher-container .scaleEditor input[type=color]:disabled {\n  margin-top: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
